import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ArticleModel } from '../../blog/ng-store/model/article.model';
import {ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-section-blog',
    templateUrl: './section-blog.component.html',
    styleUrls: ['./section-blog.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class SectionBlogComponent {
  articles: Array<ArticleModel> = [];

  constructor(private readonly route: ActivatedRoute) {
    this.articles = this.route.snapshot.data['articles'] ?? [];
  }
}
